import type { PersonalInfoState } from '../personal/personalInfoSlice';

export const isConsentsValid = (state: PersonalInfoState) => Boolean(state.termsAccepted);
